function daysBetween(startDate: Date, endDate: Date) {
    // The number of milliseconds in one day
    const oneDay = 1000 * 60 * 60 * 24

    // Convert both dates to UTC timestamps at midnight to ignore local time
    const startUTC = Date.UTC(startDate.getFullYear(), startDate.getMonth(), startDate.getDate())
    const endUTC = Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())

    // Calculate the difference in milliseconds
    const differenceMs = Math.abs(endUTC - startUTC)

    // Convert the difference to days and return
    return Math.floor(differenceMs / oneDay)
}

export const getYearLabel = (startDate: Date, endDate: Date) => {
    let year: string

    if (startDate.getFullYear() === endDate.getFullYear()) {
        year = `${startDate.getFullYear()}`
    } else if (startDate.getFullYear() + 1 === endDate.getFullYear()) {
        // one year difference
        const endOfStartYear = new Date(startDate.getFullYear(), 11, 31, 23, 59, 59, 999)

        const beginningOfEndYear = new Date(endDate.getFullYear(), 0, 1)

        const startDiff = daysBetween(startDate, endOfStartYear)
        const endDiff = daysBetween(beginningOfEndYear, endDate)

        // gives approximately a month buffer into a year. then use both years
        // 0.083 is approximately a month
        if (startDiff > endDiff && endDiff / startDiff > 0.083) {
            year = `${startDate.getFullYear()}`
        } else if (startDiff < endDiff && startDiff / endDiff > 0.083) {
            // approximately a month
            year = `${endDate.getFullYear()}`
        } else {
            year = `${startDate.getFullYear()} - ${endDate.getFullYear()}`
        }
    } else {
        year = `${startDate.getFullYear()} - ${endDate.getFullYear()}`
    }

    return year
}
